import React from 'react';
import './styles.css';

export function PrivacyPolicyPage(): React.ReactElement {
  return (
    <div className="privacy-policy-page">
      <h1>Privacy Policy for TheGalleryCreatives</h1>
      <p>
        <b>1.Introduction</b>
        TheGalleryCreatives (&ldquo;we,&rdquo; &ldquo;us,&rdquo; &ldquo;our&rdquo;) is committed to
        protecting the privacy of our users (&ldquo;you,&rdquo; &ldquo;your&rdquo;). This Privacy
        Policy outlines how we collect, use, and share your personal information, and how we handle
        sensitive user and device data on our platform, in accordance with UK data protection laws.
      </p>
      <p>
        <b>2.Data We Collect</b>
        <b>2.1.Personal Information</b>
        <span>• Email address & usernames</span>
        <span>
          • ID for user verification purposes, to ensure the security and authenticity of users on
          our platform.
        </span>
        <span>• Location data:</span>
        <span> - We collect precise location coordinates.</span>
        <span> - These coordinates are recalculated and stored as approximate location data.</span>
        <span>
          {' '}
          - The approximate location and corresponding region name are stored and may be shared with
          other users.
        </span>
      </p>
      <p>
        <b>2.2.Usage Data</b>
        <span>
          • We may collect information on how you use our platform, including interactions with
          other users, saved content, and engagement metrics. This data helps us improve our
          services and provide a better user experience. Please note that we may use third-party
          tools, such as Firebase and Brand.io, to gather and analyze this information.
        </span>
      </p>
      <p>
        <b>3.Legal Basis for Processing Personal Data</b>
        We collect and process your data based on the following legal grounds:
        <span>
          • Consent: When you provide explicit permission for us to collect and use your data.
        </span>
        <span>
          • Contractual necessity: When processing is required to fulfil our obligations to you
          (e.g., providing services you requested).
        </span>
        <span>
          • Legitimate interest: Forthe purpose ofimproving our services, marketing,fraud
          prevention, and user verification.
        </span>
      </p>
      <p>
        <b>4.How We Use Your Data</b>
        <b>4.1.Service Provision</b>
        <span>• To create and manage your account.</span>
        <span>• To verify your identity and ensure a safe environmentfor all users.</span>
      </p>
      <p>
        <b>4.2.Enhancing User Experience</b>
        <span>• Personalising your experience and recommendations on the platform.</span>
        <span>• Monitoring app performance and improving features.</span>
      </p>
      <p>
        <b>4.3.Communication</b>
        <span>• To provide customer support and respond to enquiries.</span>
      </p>
      <p>
        <b>4.4.Fraud Prevention & Security</b>
        <span>• Using ID and other information to prevent fraud and misuse ofthe platform.</span>
        <span>• Monitoring activity to detect and investigate suspicious behaviour.</span>
      </p>
      <p>
        <b>5.Data Retention</b>
        We retain your personal information for as long as necessary to provide you with our
        services or as required by law.
      </p>
      <p>
        <b>6.Children&apos;s Privacy</b>
        Our platform is not intended for users under the age of 16. If we become aware that we have
        collected data from a child under this age without parental consent, we will promptly delete
        it.
      </p>
      <p>
        <b>7.Security Measures</b>
        We use industry-standard security measures, including encryption, access control, and secure
        servers, to protect your data. However, no method of transmission over the Internet or
        electronic storage is 100% secure, and we cannot guarantee absolute security.
      </p>
      <p>
        <b>8.Data Transfers</b>
        Your personal information may be processed or stored outside the UK. If this occurs, we take
        necessary steps to ensure your data is protected under UK data protection laws, including
        using standard contractual clauses where required.
      </p>
      <p>
        <b>9. User Rights</b>
        You have the right to:
        <span>• Access, update, or delete your personal information.</span>
        <span>• Withdraw your consent at any time.</span>
        <span>• Request the deletion of your account and associated data.</span>
        To exercise these rights, contact us at chris@thegallerycreatives.com
      </p>
      <p>
        <b>10.Changes to this Policy</b>
        We may update this Privacy Policy from time to time. Any changes will be posted on this
        page, and significant changes will be communicated to you through the app or via email.
      </p>
      <p>
        <b>11.Contact Us</b>
        For questions or concerns aboutthis Privacy Policy, please contact us at: Email:
        chris@thegallerycreatives.com
      </p>
    </div>
  );
}
